import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHelper } from './api.helper';
import { CommonHelper } from "./common.helper";
import { ConstantHelper } from "./constant.helper";
import { UploadService } from '../_services/upload.service';
import { AppConfig } from '../app.config';
import { UserService } from '../_services/user.service';
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { Location } from '@angular/common';
import {
    HttpClient,
    HttpParams,
    HttpRequest,
    HttpHeaders,
  } from "@angular/common/http";
import { ClassGetter } from '@angular/compiler/src/output/output_ast';
import { ChangeDetectorRef } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class AiSummaryCommonHelper {  
  httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    httpOptions = {
      headers: this.httpHeaders,
    };
   
  isVideoFile: boolean;
  summaryPopup : any = false;
  selectedAiSummary: any = {};
  isDisabled: boolean = false;
//   cdr: any;
  showModificationFields: boolean;  
  isRegenerate: boolean = false;
  isPreview: boolean = false;
  copyTooltip: string = "Copy Summary";
  blobUrl: any;
  isSatisfied: false;
  documentUrlToGenerateAiSummary:any;
  documentIdToGenerateAiSummary:any;
    summaryAnswer: any;
    showLoader: boolean;
    delegateId: any;
    loggedInUserId: any;
    userId: any;
    demographicId: any;
    associatedFileName: any;
    associatedFileToUpload: any;
    associatedFileDetails: any;
    selectedPhysiciansIds: any;
    fileName1: any;
    docType1: any;
    fileToUpload1: any;
    companySlug: any;
    flag =0;
  constructor(
    private sweetAlertHelper: SweetAlertHelper,
    private uploadService: UploadService,
    private http: HttpClient,
    private appConfig: AppConfig
    // private cdr: ChangeDetectorRef
  ) {}

public videoApiUrl = this.appConfig.getVideoApiUrl()+"analyze_video";
public imageApiUrl = this.appConfig.getVideoApiUrl()+"analyze_image";
public pdfApiUrl = this.appConfig.getTranscribeApiUrl(); 

copyAiSummary(text: string) {
  if (text) {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
     this.copyTooltip = "Copied Summary";
     setTimeout(() => {
       this.copyTooltip = "Copy Summary";
     }, 2000);    
  }
}
async generateAiSummaryOnVideoUpload(documentUrlToGenerateAiSummary, addFileDescription, addFileContent) {
    try {
        this.showLoader = true;
        const extension = await this.checkDocumentType(documentUrlToGenerateAiSummary);
        console.log("extension..", extension);  // Log extension type to verify

        const summary = await this.generateSummary(documentUrlToGenerateAiSummary, addFileDescription, addFileContent, extension, this.flag);
        this.summaryAnswer = summary;
        
        const finalData = {
            documentId: this.documentIdToGenerateAiSummary,
            aiSummary: this.summaryAnswer
        };

        this.selectedAiSummary = finalData;

        console.log("result...", this.selectedAiSummary);  // Log the result to verify the output
        this.summaryPopup = true;
        this.showLoader = false;
        
        // Return the selectedAiSummary so you can access it outside this method
        return this.selectedAiSummary;

    } catch (err) {
        console.error("Error in generateAiSummaryOnVideoUpload:", err);
    }
}

  
  async generateAiSummaryOnDocumentUpload(documentUrlToGenerateAiSummary, addFileDescription, addFileContent,documentIdToGenerateAiSummary) {
    try {
        const extension = await this.checkDocumentType(documentUrlToGenerateAiSummary);        
        const summary = await this.generateSummary(documentUrlToGenerateAiSummary, addFileDescription, addFileContent, extension,this.flag);  
        this.summaryAnswer = summary;  
        const finalData = {
            documentId: documentIdToGenerateAiSummary,
            aiSummary: this.summaryAnswer
        }; 
        console.log("image summary...",this.summaryAnswer);  
        this.selectedAiSummary = finalData; 
        // this.showLoader = true;
        const alertStatus = await this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.generateAiSummaryByClick, finalData, this.httpOptions).toPromise();
        if(alertStatus)
        {
            this.sweetAlertHelper.alertPopUp("record saved...")
            return this.selectedAiSummary;
        }
        // this.showLoader = false;
        // return this.selectedAiSummary;
        // window.location.reload();
    } catch (err) {
        console.error(err);
    }
  }
  

async generateSummary(documentUrl: string, addFileDescription: any, addFileContent: any, extension: string,flag): Promise<string> {
  try {     
      if (extension === 'PDF' || extension === 'Image' || extension === 'Video') {
        this.showLoader = true;
          const response = await this.summarizeReport(documentUrl, extension,addFileDescription, addFileContent,flag).toPromise();
          console.log("response...",response);
          this.summaryAnswer = response.answer;
          this.showLoader = false;
      } else {
          console.error('Unknown document type');
      }
      this.summaryAnswer = String(this.summaryAnswer || '').replace(/```html/g, "").replace(/```/g, "").trim();
      console.log("summaryAnswer...",this.summaryAnswer);
      return this.summaryAnswer;
  } catch (error) {
      console.error('Error generating summary:', error);
      throw error;
  }
}

async checkDocumentType(url: string): Promise<string> {
  this.showLoader = true;  
  try {
    const response = await this.http.get(url, { responseType: 'blob' }).toPromise();
    const contentType = response.type;
    if (contentType === 'application/pdf') {
      this.showLoader = false;
      return 'PDF';
    } else if (contentType.startsWith('image/')) {
      this.showLoader = false;
      return 'Image';
    } else if (contentType.startsWith('video/')) {
    //   this.showLoader = false;
      return 'Video';
    } else {
      this.showLoader = false;
      return 'Unknown';
    }
  } catch (error) {
    console.error('Error fetching document:', error);
    throw error;
  }
}

summarizeReport(documentUrl: string, extension: string, addFileDescription: any, addFileContent:any,flag:any): Observable<any> { 
let Pdfpayload;
let videoPayload;
let imagePayload;
 const pdf_blob_urls = Array.isArray(documentUrl) ? documentUrl : [documentUrl];
  const isMultiple = pdf_blob_urls.length > 1;

  // Dynamically select endpoint
  // pdfApiUrl = this.appConfig.getTranscribeApiUrl() + (isMultiple ? "reports" : "patientReport");
  const pdfUrl = this.pdfApiUrl+(isMultiple ? "reports" : "patientReport");
  if(flag == 0)
    {    
    Pdfpayload = {
      question: `Summarize the report based on  ${addFileDescription} and ${addFileContent} `,
      pdf_blob_urls
    };

    videoPayload = {
      video_data: documentUrl,
      // video_question: `following is the video of ${addFileDescription} and ${addFileContent} ,provide an analysis from radiologist perspective and give a diagnosis if required. Make sure to provide descriptive analysis with minimum 80 words. Display the information as HTML paragraph only using <b>, <h6>, and <ul> for bullet points and don't provide any additional information or explanation about HTML tags used. Make sure to provide the analysis in the same language as the video.`
      video_question: `You are a board-certified radiologist with over 30 years of experience. Please analyze the provided medical video using ${addFileDescription} and ${addFileContent} as context. Your response should include:
Organ-specific findings - Clearly describe the anatomical structures involved and any notable abnormalities using proper medical terminology (e.g., hyperechoic, heterogeneous, calcifications, lymphadenopathy, etc.).
Radiologist's interpretation - Provide your expert analysis using concise, technical language, interpreting the visual data based on radiological standards.
Diagnostic impression - Conclude with a diagnostic summary or differential diagnosis, articulated in a manner appropriate for a formal radiology report.
Please ensure your report is comprehensive and descriptive, containing at least 80 words, and written in the professional tone of a practicing radiologist.
 Display the information as HTML paragraph only using <b>, <h6>, and <ul> for bullet points and don't provide any additional information or explanation about HTML tags used.`
    }

    imagePayload = {
      img_data: documentUrl,
      question: `You are a board-certified radiologist with over 30 years of experience. Please analyze the provided medical video using ${addFileDescription} and ${addFileContent} as context. Your response should include:
Organ-specific findings - Clearly describe the anatomical structures involved and any notable abnormalities using proper medical terminology (e.g., hyperechoic, heterogeneous, calcifications, lymphadenopathy, etc.).
Radiologist's interpretation - Provide your expert analysis using concise, technical language, interpreting the visual data based on radiological standards.
Diagnostic impression - Conclude with a diagnostic summary or differential diagnosis, articulated in a manner appropriate for a formal radiology report.
Please ensure your report is comprehensive and descriptive, containing at least 80 words, and written in the professional tone of a practicing radiologist.
Display the information as HTML paragraph only using <b>, <h6>, and <ul> for bullet points and don't provide any additional information or explanation about HTML tags used.` 
    }    
    }
    else
    {
        Pdfpayload = {
            question: addFileDescription ? addFileDescription : 'Summarize the report',
            pdf_blob_urls: [documentUrl]
          };
      
        videoPayload = {
            video_data: documentUrl,
            //video_question: "This is the previous summary what you have generated \n"+addFileContent+"\n"+addFileDescription ? "This is the previous summary what you have generated \n"+addFileContent+"\n"+addFileDescription: "if it is MRI/CT scan or X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points"
            video_question: "You are a board-certified radiologist with over 30 years of experience. Please analyze the provided medical video using This previous summary what you have generated \n"+addFileContent+"\n"+addFileDescription +"provide reanalysis and Display as HTML paragraph only using <b>, only <h6> and <ul> for bullet points" ? "You are a board-certified radiologist with over 30 years of experience. Please analyze the provided medical video using This previous summary what you have generated \n"+addFileContent+"\n"+addFileDescription+"\n provide reanalysis in descriptive and Display as HTML paragraph only using <b>, only <h6> and <ul> for bullet points": "if it is MRI/CT scan or X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points"
          }
      
        imagePayload = {
            img_data: documentUrl,
            question: "This is the previous summary what you have generated \n"+addFileDescription+"\n For the given image if it is MRI/CT scan or  X-ray, provide an analysis from radiologist perspective and give a analysis if any diagnosis is required or not, else return its not the MRI/CT Scan or xray, Display the information as HTML paragraph only using <b>, only <h6> and <ul> for bullet points" 
          }          
    }
    console.log("....this.pdfApiUrl",pdfUrl);
    console.log("...this.imageApiUrl",this.imageApiUrl);
    console.log("...videoApiUrl",this.videoApiUrl)
 
  if(extension == 'PDF'){    
    return this.http.post<any>(pdfUrl, Pdfpayload);
  } else if (extension == 'Image'){
    return this.http.post<any>(this.imageApiUrl, imagePayload);
  } else if (extension == 'Video'){
    return this.http.post<any>(this.videoApiUrl, videoPayload);
  }
}
    
}
